import { Component, OnInit ,Inject, EventEmitter} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../common.service';
@Component({
  selector: 'app-viewallride',
  templateUrl: './viewallride.component.html',
  styleUrls: ['./viewallride.component.scss']
})
export class ViewallrideComponent implements OnInit {
  dataview: any;
  isopen = new EventEmitter()
  data1: any;
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,public dialog: MatDialog,private service:CommonService,private dialogRef: MatDialogRef<ViewallrideComponent>) { }

  ngOnInit(): void {
    this.data1=this.data
    this.viewride()
  }
  viewride(){
    this.service.viewallride(this.data).subscribe((res: any) => {
this.dataview=res.data




})

  }
  onCloseDialog(): void {
    this.dialogRef.close();
  }
}
